<fs-sidenav-menu-items>
  <button fs-sidenav-menu-item (click)="switchOrganization()">Switch to organization experience</button>
</fs-sidenav-menu-items>
